// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Mywn","content":"styles_content__2cs1g","checkbox":"styles_checkbox__3BbLy","checkboxLabel":"styles_checkboxLabel__UH-DL"};